import React from "react";
// import CountUp from "react-countup";
// import VisibilitySensor from "react-visibility-sensor";
import LaxDiv from "../Shared/LaxDiv";

class FunFact extends React.Component {
  state = {
    didViewCountUp: false,
  };

  onVisibilityChange = (isVisible) => {
    if (isVisible) {
      this.setState({ didViewCountUp: true });
    }
  };

  render() {
    const data = [
      {
        id: 1,
        subheading: "BAG",
        image: "/assets/images/bag.svg",
        color: "#F04C31",
      },

      {
        id: 2,
        subheading: "T-SHIRT",
        image: "/assets/images/tshirt.svg",
        color: "#00acee",
      },

      {
        id: 3,
        subheading: "CAP",
        image: "/assets/images/cap.svg",
        color: "#8dc63f",
      },

      {
        id: 4,
        subheading: "SURPRISE BOX",
        image: "/assets/images/gift.svg",
        color: "#efa506",
      },
    ];
    return (
      <div >
      <div className="container">
                    <div className="section-title">
                        <span>Kit</span>
                        <h2>PROPOSED REGISTRATION KIT</h2>
                        <div className="bar"></div>
                        <LaxDiv text="KIT" dataPreset="driftRight" />
                        {/* <Link to="#" className="btn btn-primary">View More Speakers</Link> */}
                    </div>
         </div>
        <section 
          className="funfacts-area "
          style={{ backgroundColor: "transparent" }}
        >
            <div className="row" style={{margin:"0px"}}>
              {data.map((i, index) => (
                <div
                  className="col-lg-3 col-12 col-sm-6 ptb-80"
                  style={{ backgroundColor: i.color }}
                  key={index}
                >
                  <div className="single-funfact">
                    <div className="icon">
                      <img src={i.image} style={{ height: "8rem" }} alt="icon" />
                    </div>
                    <h3
                      style={{
                        color: "white",
                        fontSize: "2rem",
                        marginTop: "1rem",
                      }}
                    >
                      {i.subheading}
                    </h3>
                  </div>
                </div>
              ))}
            </div>
        </section>
    
      </div>
       
  
    );
  }
}

{
  /* <div className="col-lg-6 col-6 col-sm-6">
                            <div className="single-funfact">
                                <div className="icon">
                                <img style={{height:"10rem"}}
                                     src={require("../../assets/images/Donation.svg")} 
                                        alt="speaker" 
                                    />
                                </div>
                                <p style={{paddingTop:"2rem",fontSize:"15px",lineHeight:"2rem"}}>$ 30,OOO/- CSR SUPPORT FOR SERVICE PROJECT/GLOBAL GRANT FOR ALL ATTENDING DISTRICTS</p>
                            </div>
                        </div> */
}

{
  /* <div className="col-lg-2 col-2 col-sm-2">
                            <div className="single-funfact">
                                <div className="icon">
                                    <i className="icofont-copy"></i>
                                </div>
                                <h3 className="odometer">
                                    <VisibilitySensor
                                        onChange={this.onVisibilityChange}
                                        offset={{
                                            top: 10
                                        }}
                                        delayedCall
                                    >
                                        <CountUp
                                            start={0}
                                            end={
                                                this.state.didViewCountUp
                                                    ? 100
                                                    : 0
                                            }
                                            duration={3}
                                        />
                                    </VisibilitySensor>
                                </h3>
                                <p>Sponsors</p>
                            </div>
                        </div> */
}

{
  /* <div className="col-lg-2 col-2 col-sm-2">
                            <div className="single-funfact">
                                <div className="icon">
                                    <i className="icofont-users-social"></i>
                                </div>
                                <h3 className="odometer">
                                    <VisibilitySensor
                                        onChange={this.onVisibilityChange}
                                        offset={{
                                            top: 10
                                        }}
                                        delayedCall
                                    >
                                        <CountUp
                                            start={0}
                                            end={
                                                this.state.didViewCountUp
                                                    ? 99
                                                    : 0
                                            }
                                            duration={3}
                                        />
                                    </VisibilitySensor>
                                </h3>
                                <p>Total Attendance</p>
                            </div>
                        </div>
                         */
}

export default FunFact;
